import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Mutation} from 'react-apollo'
import {Button} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {toast} from 'react-toastify'

import ClientCommunicationMethodsList from "../client/ClientCommunicationMethodsList";
import ClientContactInput from "../client/ClientContactInput";
import upsertClientContactsMutation from "../../../queries/server/mutations/upsert_client_contacts";
import editClientLocalMutation from "../../../queries/client_side/mutations/edit_client";
import removeClientContactMutation from '../../../queries/server/mutations/remove_client_contact'
import upsertClientContactCommunicationMethodsMutation
    from '../../../queries/server/mutations/upsert_client_contact_communication_methods'
import LoadingButton from "../LoadingButton";
import CommunicationMethodInput from "../communication_method/CommunicationMethodInput";
import ClientContactCommunicationMethodsList from "../client/ClientContactCommunicationMethodsList";

class ContactListItem extends Component {

    constructor(props) {
        super(props)
        this.state = {
            ...props,
            editing: false,
            showInput: false,
            newContactMethod: {contact_info: '', contact_medium_id: ''}
        }
    }

    contactChanged = ({key, value}) => {
        const newData = {}
        newData[key] = value
        this.setState({...newData})
    }

    onContactMediumChanged = (contact_medium_id) => {
        this.setState({newContactMethod: {...this.state.newContactMethod, contact_medium_id}})
    }

    onContactInfoChanged = (contact_info) => {
        this.setState({newContactMethod: {...this.state.newContactMethod, contact_info}})
    }

    resetNewContactMethod = () => {
        this.setState({newContactMethod: {contact_info: '', contact_medium_id: ''}})
    }

    render() {

        const {contact_id, first_name, last_name, position, editing, showInput, newContactMethod} = this.state
        const {client_id, communication_methods} = this.props

        return (
            <Mutation mutation={editClientLocalMutation}>
                {(editClientLocalMutationFunc) => (
                    <div className="d-flex flex-column border-bottom pt-2" style={{flex: 1}}>

                        {editing && <Mutation mutation={upsertClientContactsMutation}>
                            {(upsertClientContactsMutationFunc, {loading}) => (

                                <ClientContactInput
                                    onSave={() => {
                                        upsertClientContactsMutationFunc({
                                            variables: {
                                                client_id,
                                                data: [{contact_id, first_name, last_name, position}]
                                            }
                                        })
                                            .then(({data}) => {
                                                editClientLocalMutationFunc({variables: {data: data.upsertClientContact}})
                                                toast.success('Client Contact Updated', {autoClose: 2000})
                                                this.setState({editing: false})
                                            })
                                            .catch(e => toast.error(e.message, {autoClose: false}))
                                    }}
                                    onCancel={() => this.setState({editing: false})}
                                    onChange={this.contactChanged}
                                    loading={loading}
                                    first_name={first_name}
                                    last_name={last_name}
                                    position={position}
                                />
                            )}
                        </Mutation>
                        }

                        {!editing && <div className="d-flex flex-row align-items-center">
                            <div className="d-flex flex-column" style={{flex: 1}}>
                                <h5>{first_name} {last_name}</h5>
                                <span className="text-dark">{position}</span>
                            </div>
                            <LoadingButton
                                icon="edit"
                                loading={false}
                                size="sm"
                                className="square-btn ml-1"
                                color="warning"
                                onClick={() => this.setState({editing: true})}
                            />
                            <Mutation mutation={removeClientContactMutation}>
                                {(removeClientContactMutationFunc, {loading}) => (
                                    <LoadingButton
                                        icon="trash-alt"
                                        loading={loading}
                                        size="sm"
                                        className="square-btn ml-1"
                                        color="danger"
                                        onClick={() => {
                                            removeClientContactMutationFunc({variables: {client_id, ids: [contact_id]}})
                                                .then(({data}) => {
                                                    editClientLocalMutationFunc({variables: {data: data.removeClientContacts}})
                                                    toast.success('Client Contact Removed', {autoClose: 2000})
                                                    this.setState({editing: false})
                                                })
                                                .catch(e => toast.error(e.message, {autoClose: false}))
                                        }}
                                    />)}
                            </Mutation>
                        </div>}

                        {communication_methods &&
                        <ClientContactCommunicationMethodsList contact_id={contact_id} client_id={client_id}
                                                               communicationMethods={communication_methods}/>}
                        {!showInput && <Button
                            outline
                            block
                            size="sm"
                            color="success"
                            className="mt-2 mb-2"
                            onClick={() => this.setState({showInput: true})}
                        >
                            <FontAwesomeIcon
                                icon="plus"
                                className="text-success"
                            />{' '}
                            Add Contact Method
                        </Button>}

                        {showInput && <Mutation
                            mutation={upsertClientContactCommunicationMethodsMutation}>
                            {(upsertClientContactCommunicationMethodsMutationFunc) => (
                                <CommunicationMethodInput
                                    {...newContactMethod}
                                    saving={false}
                                    onContactMediumChanged={this.onContactMediumChanged}
                                    onContactInfoChanged={this.onContactInfoChanged}
                                    onCancel={() => this.setState({showInput: false})}
                                    onSave={() => {
                                        upsertClientContactCommunicationMethodsMutationFunc({
                                            variables: {
                                                client_id,
                                                contact_id,
                                                data: [{...newContactMethod}]
                                            }
                                        })
                                            .then(({data}) => {
                                                editClientLocalMutationFunc({variables: {data: data.upsertClientContactCommunicationMethod}})
                                                toast.success('Communication Method Added', {autoClose: 2000})
                                                this.setState({showInput: false})
                                                this.resetNewContactMethod()
                                            })
                                            .catch(e => toast.error(e.message, {autoClose: false}))
                                    }}
                                />
                            )}

                        </Mutation>}


                    </div>)}
            </Mutation>


        )
    }
}

ContactListItem.propTypes = {
    client_id: PropTypes.number.isRequired,
    contact_id: PropTypes.number.isRequired,
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
    position: PropTypes.string.isRequired,
    communication_methods: PropTypes.array
}

export default ContactListItem